/* ABC: панель корзины закрывается кликом мимо неё, как на abcclothes.ru.
   Диалог открыт нештатно (dialog.show, а не showModal), поэтому браузер
   сам по клику вне окна его не закрывает — делаем руками.
   Клик по самой кнопке корзины пропускаем, иначе она откроется и тут же закроется. */
(function () {
  /* Закрытие должно быть плавным, как открытие. dialog.close() гасит
     элемент мгновенно (display:none), поэтому сначала проигрываем
     обратную анимацию, а нативный close() зовём по её окончании.
     Патчим сам метод close у элемента, чтобы плавно уходило любое
     закрытие — наше, темы или кнопки оформления заказа. */
  var nativeClose = HTMLDialogElement.prototype.close;
  var nativeShow = HTMLDialogElement.prototype.show;
  var nativeShowModal = HTMLDialogElement.prototype.showModal;

  function animateClose(d) {
    if (d.dataset.abcClosing) return;
    d.dataset.abcClosing = '1';
    d.classList.add('abc-drawer-closing');
    var token = (d.abcCloseToken = (d.abcCloseToken || 0) + 1);
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      if (d.abcCloseToken !== token) return; // закрытие отменили — корзину снова открыли
      d.classList.remove('abc-drawer-closing');
      delete d.dataset.abcClosing;
      nativeClose.call(d);
    }
    d.addEventListener('animationend', finish, { once: true });
    // страховка, если анимация не стартовала (prefers-reduced-motion, фон)
    setTimeout(finish, 450);
  }

  /* ABC 24.09: тема сама иногда делает «close() и сразу show()/showModal()» —
     поднять корзину поверх других окон или сменить режим при повороте экрана.
     Раньше наш close() запускал анимацию ухода, а следующий showModal() падал
     с ошибкой (диалог ещё открыт) — корзина «глючила»: начинала уезжать,
     дёргалась. Теперь закрытие стартует на микрозадачу позже: если тема
     следом открывает диалог, закрытие отменяется и корзина остаётся на месте. */
  function cancelClose(d) {
    var had = false;
    if (d.abcPendingClose) { d.abcPendingClose = false; had = true; }
    if (d.dataset.abcClosing) {
      d.abcCloseToken = (d.abcCloseToken || 0) + 1;
      d.classList.remove('abc-drawer-closing');
      delete d.dataset.abcClosing;
      had = true;
    }
    if (had && d.open) nativeClose.call(d);
  }

  function patch(d) {
    if (!d || d.dataset.abcPatched) return;
    d.dataset.abcPatched = '1';
    d.close = function () {
      if (!this.open || this.abcPendingClose || this.dataset.abcClosing) return;
      var self = this;
      self.abcPendingClose = true;
      queueMicrotask(function () {
        if (!self.abcPendingClose) return;
        self.abcPendingClose = false;
        animateClose(self);
      });
    };
    d.show = function () { cancelClose(this); if (!this.open) return nativeShow.call(this); };
    d.showModal = function () { cancelClose(this); if (!this.open) return nativeShowModal.call(this); };
  }

  function drawer() {
    var d = document.querySelector('#cart-drawer dialog');
    return d && d.open ? d : null;
  }

  document.addEventListener('pointerdown', function (e) {
    var d = drawer();
    if (!d) return;
    if (d.contains(e.target)) return;
    if (e.target.closest && e.target.closest('[aria-controls="cart-drawer"]')) return;
    /* окно выбора размера/цвета (abc-sheet) открывается ПОВЕРХ корзины отдельным
       диалогом — касание по нему не «мимо корзины». Раньше выбор размера
       закрывал мини-корзину (жалоба владельца 24.09). */
    if (e.target.closest && e.target.closest('dialog.abc-sheet')) return;
    var sheet = document.querySelector('dialog.abc-sheet[open]');
    if (sheet) return;
    /* ABC 29.09: окно выбора страны (CHANGE в корзине) лежит поверх корзины — касание по нему не «мимо» */
    var cc = document.getElementById('AbcCountry');
    if (cc && cc.open) return;
    closeDrawer(d);
    swallowClick();
  }, true);

  /* 25.09: нажатие мимо открытой корзины/фильтра только закрывает панель —
     следующий за ним click (по товару, ссылке) гасим, чтобы не открывался товар */
  function swallowClick() {
    function stop(ev) { ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); }
    window.addEventListener('click', stop, { capture: true, once: true });
    setTimeout(function () { window.removeEventListener('click', stop, { capture: true }); }, 600);
  }
  window.abcSwallowClick = swallowClick;

  /* 24.09: закрываем через сам компонент темы (theme-drawer.close), а не только
     диалог — иначе тема считала корзину открытой: иконка корзины открывала её
     лишь со второго нажатия, а после повторного добавления товара она не выезжала */
  function closeDrawer(d) {
    var comp = d.closest('theme-drawer, cart-drawer-component');
    var host = document.querySelector('#cart-drawer');
    if (host && typeof host.close === 'function' && host !== d) { host.close(); return; }
    if (comp && comp !== d && typeof comp.close === 'function') { comp.close(); return; }
    d.close();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = drawer();
    if (d) closeDrawer(d);
  });

  // Страховка: панель не должна быть открыта при заходе на страницу.
  // Владелец жаловался, что корзина всегда открыта; в чистой сессии
  // такого нет, но состояние иногда залипает — закрываем на всякий случай.
  function closeOnLoad() {
    var d = document.querySelector('#cart-drawer dialog');
    if (!d) return;
    patch(d);
    // при заходе на страницу закрываем без анимации — нативным методом
    if (d.open) nativeClose.call(d);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', closeOnLoad);
  else closeOnLoad();
  window.addEventListener('pageshow', closeOnLoad);

  // панель перерисовывается при обновлении корзины — подхватываем заново
  new MutationObserver(function () {
    patch(document.querySelector('#cart-drawer dialog'));
  }).observe(document.documentElement, { childList: true, subtree: true });

})();

/* ABC: полноэкранная корзина на телефоне — крестик ставим ровно на место
   иконки корзины в шапке. Позиция иконки зависит от прокрутки (бегущая
   строка есть или уже уехала), поэтому меряем при каждом открытии. */
(function () {
  function place(dlg) {
    var icon = document.querySelector('cart-icon') ||
               document.querySelector('.header-actions__cart-icon');
    if (!icon) return;
    var ri = icon.getBoundingClientRect();
    if (!ri.width || !ri.height) return;
    /* по вертикали — строка шапки целиком (на ПК сама иконка всего 14px,
       а линия шапки ниже), по горизонтали — иконка корзины */
    var rowEl = icon.closest('.header__columns, .header__row') || icon;
    var rr = rowEl.getBoundingClientRect();
    var r = { top: rr.top, height: rr.height, width: ri.width, right: ri.right };
    dlg.style.setProperty('--abc-cart-top', Math.max(0, Math.round(r.top)) + 'px');
    dlg.style.setProperty('--abc-cart-h', Math.round(r.height) + 'px');
    dlg.style.setProperty('--abc-cart-w', Math.round(r.width) + 'px');
    dlg.style.setProperty('--abc-cart-right', Math.round(window.innerWidth - r.right) + 'px');
    /* строка заголовка начинается не с верха окна (у шторки свой отступ
       ~16px), поэтому её верхний отступ считаем от реального начала */
    var hdr = dlg.querySelector('.theme-drawer__header');
    if (hdr) {
      var off = hdr.getBoundingClientRect().top - dlg.getBoundingClientRect().top;
      dlg.style.setProperty('--abc-cart-pad', Math.max(0, Math.round(r.top - off)) + 'px');
      /* высота блока заголовка — чтобы линия под ним шла ровно по низу
         строки «CART / ×», где бы ни была шапка в момент открытия */
      var top = Math.max(0, Math.round(r.top));
      /* (51) без округления: линия ровно на линии шапки (у шапки дробные координаты — иначе стык «ступенькой») */
      dlg.style.setProperty('--abc-cart-hdr-h', Math.max(0, rr.bottom - dlg.getBoundingClientRect().top - off) + 'px');
    }
  }
  function watch() {
    var dlg = document.querySelector('#cart-drawer dialog');
    if (!dlg || dlg.dataset.abcCartPlace) return;
    dlg.dataset.abcCartPlace = '1';
    new MutationObserver(function () {
      if (dlg.hasAttribute('open')) place(dlg);
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    if (dlg.hasAttribute('open')) place(dlg);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ABC 25.09 (38): блок «минус на последней штуке удаляет товар» (min=0) убран —
   владелец путался: товар пропадал. Теперь на 1 «−» неактивен (тема: min=1),
   удаление только DELETE. См. блок (38) в конце файла. */

/* ABC: удаление товара — строка пропадает сразу, без анимации темы
   (владелец: «дёрганая»). Остальные строки смыкаются, тема затем
   перерисовывает корзину уже без этой строки. */
(function () {
  function hideRow(el) {
    var row = el.closest('.cart-items__table-row');
    if (row) row.style.display = 'none';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.cart-items__remove');
    /* прячем ПОСЛЕ клика: если спрятать во время, шторка решает, что
       клик был мимо неё (кнопка уже не видна), и закрывается */
    if (t) { setTimeout(function () { hideRow(t); }, 0); }
  }, true);
})();

/* ABC 24.09: панель фильтра — строка «FILTER / ×» ровно на строке шапки сайта
   и линия под ней на уровне линии шапки, как в корзине (владелец). Шапка
   может быть с бегущей строкой или уже без неё — меряем при каждом открытии. */
(function () {
  function place(dlg) {
    var row = document.querySelector('.header__row--top') || document.querySelector('.header__row, .header__columns');
    if (!row) return;
    var rr = row.getBoundingClientRect();
    if (!rr.height) return;
    var top = Math.max(0, Math.round(rr.top));
    var off = Math.round(dlg.getBoundingClientRect().top);
    dlg.style.setProperty('--abc-fh-top', Math.max(0, top - off) + 'px');
    dlg.style.setProperty('--abc-fh-h', Math.round(rr.height) + 'px');
    /* (51) без округления — линия под FILTER ровно на линии шапки */
    dlg.style.setProperty('--abc-fh-hdr-h', Math.max(0, rr.bottom - dlg.getBoundingClientRect().top) + 'px');
  }
  function watch() {
    var dlg = document.querySelector('#filters-drawer dialog, theme-drawer dialog:has(.facets)');
    if (!dlg || dlg.dataset.abcFhPlace) return;
    dlg.dataset.abcFhPlace = '1';
    new MutationObserver(function () {
      if (dlg.hasAttribute('open')) place(dlg);
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    if (dlg.hasAttribute('open')) place(dlg);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
})();


/* ABC 24.09: панель фильтра закрывается нажатием мимо неё, как корзина.
   Тема на ПК открывает её не модально — браузер сам мимо не закрывает. */
(function () {
  document.addEventListener('pointerdown', function (e) {
    var host = document.querySelector('#filters-drawer');
    var d = host && host.querySelector('dialog');
    if (!d || !d.open || !host.isOpen) return;
    if (d.contains(e.target)) return;
    if (e.target.closest && e.target.closest('.facets-toggle, .facets-toggle__button, [aria-controls="filters-drawer"], dialog.abc-sheet')) return;
    var cc = document.getElementById('AbcCountry');
    if (cc && cc.open) return;
    /* на телефоне панель во всю ширину — «мимо» там только затемнение самого диалога */
    host.close();
    if (window.abcSwallowClick) window.abcSwallowClick();
  }, true);
})();

/* ABC 25.09 (38): «−» при количестве 1 больше не удаляет товар. Владелец жал «−»,
   строка пропадала (тема ставила 0 = удалить) — удаление только кнопкой DELETE, как
   у Moncler. Кнопка на единице — неактивна (класс abc-min, стиль в abc-custom.css). */
(function () {
  function qtyOf(btn) {
    /* не [class*=quantity]: под него попадает сама кнопка quantity-minus */
    var box = btn.closest('quantity-selector-component, .quantity-selector');
    var inp = box && box.querySelector('input');
    return inp ? parseInt(inp.value, 10) : NaN;
  }
  function mark() {
    document.querySelectorAll('cart-items-component .quantity-minus').forEach(function (b) {
      b.classList.toggle('abc-min', qtyOf(b) <= 1);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-items-component .quantity-minus');
    if (!b || !(qtyOf(b) <= 1)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
  var q = false;
  new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; mark(); }); })
    .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  document.addEventListener('input', mark, true);
  document.addEventListener('change', mark, true);
})();
